import React from 'react'

import { Route, Routes } from 'react-router-dom'
import { nestedRoutePath, routes } from '../../../../constants/routes'

import CreateReceipt from './create'
import ViewReceipt from './view'
import ListReceipts from './list'

const ReceiptsIndex = () => {
    return (
        <Routes>
            <Route path={nestedRoutePath(routes.adminFinanceReceiptsIndex, routes.adminFinanceReceiptsCreate)} element={<CreateReceipt />} />
            <Route path={nestedRoutePath(routes.adminFinanceReceiptsIndex, routes.adminFinanceReceiptsView)} element={<ViewReceipt />} />
            <Route index element={<ListReceipts />} />
        </Routes>
    )
}

export default ReceiptsIndex
